import { createSvgIcon } from '@mui/material';

export const FO = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='76'
    height='76'
    viewBox='0 0 76 76'
    fill='none'
  >
    <path
      d='M33.5771 27.6982C33.5771 27.0804 33.8862 26.5035 34.4006 26.1612L38.9844 23.111C39.615 22.6914 40.4379 22.6995 41.0601 23.1315L45.2022 26.0076C45.814 26.4325 46.6212 26.448 47.249 26.047L51.9189 23.0638C52.5355 22.6699 53.3264 22.6773 53.9355 23.0826L58.562 26.1612C59.0764 26.5035 59.3854 27.0804 59.3854 27.6982V33.4497C59.3854 34.4693 58.5589 35.2959 57.5393 35.2959H35.4233C34.4037 35.2959 33.5771 34.4693 33.5771 33.4497V27.6982Z'
      fill='url(#paint0_linear_515_130)'
    />
    <rect
      x='50.9385'
      y='28.083'
      width='6.45207'
      height='3.22003'
      rx='1.61002'
      fill='#F5F5F5'
    />
    <path
      d='M33.5771 32.7842H59.1632V33.3996C59.1632 34.4192 58.3367 35.2457 57.3171 35.2457H35.4233C34.4037 35.2457 33.5771 34.4192 33.5771 33.3996V32.7842Z'
      fill='#B76E00'
    />
    <rect
      x='16.6162'
      y='24.4766'
      width='14.7692'
      height='10.7692'
      rx='1.84615'
      fill='url(#paint1_linear_515_130)'
    />
    <path
      d='M16.6162 32.7842H31.3854V33.3996C31.3854 34.4192 30.5589 35.2457 29.5393 35.2457H18.4624C17.4428 35.2457 16.6162 34.4192 16.6162 33.3996V32.7842Z'
      fill='#2962FF'
    />
    <ellipse
      cx='46.5676'
      cy='14.6021'
      rx='6.92308'
      ry='6.91019'
      fill='#2962FF'
    />
    <ellipse
      cx='46.5676'
      cy='13.9869'
      rx='6.92308'
      ry='6.91019'
      fill='url(#paint2_linear_515_130)'
    />
    <rect
      width='4.63062'
      height='27.6923'
      rx='1.53846'
      transform='matrix(-1 0 0 1 67.3857 37.7075)'
      fill='url(#paint3_linear_515_130)'
    />
    <rect
      width='4.63062'
      height='27.6923'
      rx='1.53846'
      transform='matrix(-1 0 0 1 13.5547 37.7075)'
      fill='url(#paint4_linear_515_130)'
    />
    <path
      d='M67.3857 59.8613H62.7551V63.8613C62.7551 64.711 63.4439 65.3998 64.2936 65.3998H65.8473C66.6969 65.3998 67.3857 64.711 67.3857 63.8613V59.8613Z'
      fill='#2962FF'
    />
    <rect
      x='16.4482'
      y='37.7075'
      width='43.412'
      height='27.6923'
      rx='1.84615'
      fill='url(#paint5_linear_515_130)'
    />
    <path
      d='M16.4482 59.8613H59.8603V63.5536C59.8603 64.5732 59.0337 65.3998 58.0141 65.3998H18.2944C17.2748 65.3998 16.4482 64.5732 16.4482 63.5536V59.8613Z'
      fill='#2962FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.4044 55.7385C10.6771 51.1944 14.8492 47.8618 19.7997 47.8618C24.6146 47.8618 28.6932 51.0144 30.0839 55.3681H31.7968C36.4973 55.3681 40.3078 59.1786 40.3078 63.8791C40.3078 68.5796 36.4973 72.3901 31.7968 72.3901H11.8958C7.19529 72.3901 3.38477 68.5796 3.38477 63.8791C3.38477 60.0454 5.91945 56.8038 9.4044 55.7385Z'
      fill='url(#paint6_linear_515_130)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.96338 53.3909C9.0363 48.3427 13.9991 44.7847 19.7994 44.7847C25.1711 44.7847 29.8239 47.8364 32.1287 52.2956C38.375 52.4714 43.3845 57.5901 43.3845 63.8789C43.3845 70.2787 38.1964 75.4668 31.7966 75.4668H11.8956C5.49573 75.4668 0.307617 70.2787 0.307617 63.8789C0.307617 59.2395 3.03212 55.2429 6.96338 53.3909ZM9.40418 55.7383C10.6769 51.1942 14.849 47.8616 19.7994 47.8616C24.6144 47.8616 28.693 51.0142 30.0837 55.3678H31.7966C36.4971 55.3678 40.3076 59.1784 40.3076 63.8789C40.3076 68.5794 36.4971 72.3899 31.7966 72.3899H11.8956C7.19506 72.3899 3.38454 68.5794 3.38454 63.8789C3.38454 60.0452 5.91923 56.8035 9.40418 55.7383Z'
      fill='#ffffff'
    />
    <path
      d='M16.3559 63.2542H19.9744V64.6542H16.3559V63.2542ZM16.4851 67.4004H14.7405V59.8619H20.4374V61.2619H16.4851V67.4004ZM25.2065 67.5296C24.6106 67.5296 24.0577 67.4327 23.548 67.2389C23.0454 67.045 22.6075 66.7722 22.2341 66.4204C21.868 66.0686 21.5808 65.6558 21.3726 65.1819C21.1716 64.7081 21.0711 64.1912 21.0711 63.6312C21.0711 63.0712 21.1716 62.5542 21.3726 62.0804C21.5808 61.6065 21.8716 61.1937 22.2449 60.8419C22.6182 60.4901 23.0562 60.2173 23.5588 60.0235C24.0613 59.8296 24.607 59.7327 25.1957 59.7327C25.7916 59.7327 26.3372 59.8296 26.8326 60.0235C27.3352 60.2173 27.7695 60.4901 28.1357 60.8419C28.509 61.1937 28.7998 61.6065 29.008 62.0804C29.2162 62.5471 29.3203 63.064 29.3203 63.6312C29.3203 64.1912 29.2162 64.7117 29.008 65.1927C28.7998 65.6665 28.509 66.0794 28.1357 66.4312C27.7695 66.7758 27.3352 67.045 26.8326 67.2389C26.3372 67.4327 25.7952 67.5296 25.2065 67.5296ZM25.1957 66.0435C25.5331 66.0435 25.8418 65.986 26.1218 65.8712C26.409 65.7563 26.6603 65.5912 26.8757 65.3758C27.0911 65.1604 27.2562 64.9055 27.3711 64.6112C27.4931 64.3168 27.5541 63.9901 27.5541 63.6312C27.5541 63.2722 27.4931 62.9455 27.3711 62.6512C27.2562 62.3568 27.0911 62.1019 26.8757 61.8865C26.6675 61.6712 26.4198 61.506 26.1326 61.3912C25.8454 61.2763 25.5331 61.2189 25.1957 61.2189C24.8582 61.2189 24.5459 61.2763 24.2588 61.3912C23.9788 61.506 23.7311 61.6712 23.5157 61.8865C23.3003 62.1019 23.1316 62.3568 23.0095 62.6512C22.8947 62.9455 22.8372 63.2722 22.8372 63.6312C22.8372 63.983 22.8947 64.3096 23.0095 64.6112C23.1316 64.9055 23.2967 65.1604 23.5049 65.3758C23.7203 65.5912 23.9716 65.7563 24.2588 65.8712C24.5459 65.986 24.8582 66.0435 25.1957 66.0435Z'
      fill='#252C7E'
    />
    <path
      d='M16.3559 62.639H19.9744V64.039H16.3559V62.639ZM16.4851 66.7852H14.7405V59.2467H20.4374V60.6467H16.4851V66.7852ZM25.2065 66.9144C24.6106 66.9144 24.0577 66.8175 23.548 66.6236C23.0454 66.4298 22.6075 66.157 22.2341 65.8052C21.868 65.4534 21.5808 65.0405 21.3726 64.5667C21.1716 64.0928 21.0711 63.5759 21.0711 63.0159C21.0711 62.4559 21.1716 61.939 21.3726 61.4652C21.5808 60.9913 21.8716 60.5785 22.2449 60.2267C22.6182 59.8749 23.0562 59.6021 23.5588 59.4082C24.0613 59.2144 24.607 59.1175 25.1957 59.1175C25.7916 59.1175 26.3372 59.2144 26.8326 59.4082C27.3352 59.6021 27.7695 59.8749 28.1357 60.2267C28.509 60.5785 28.7998 60.9913 29.008 61.4652C29.2162 61.9318 29.3203 62.4487 29.3203 63.0159C29.3203 63.5759 29.2162 64.0964 29.008 64.5775C28.7998 65.0513 28.509 65.4641 28.1357 65.8159C27.7695 66.1605 27.3352 66.4298 26.8326 66.6236C26.3372 66.8175 25.7952 66.9144 25.2065 66.9144ZM25.1957 65.4282C25.5331 65.4282 25.8418 65.3708 26.1218 65.2559C26.409 65.1411 26.6603 64.9759 26.8757 64.7605C27.0911 64.5452 27.2562 64.2903 27.3711 63.9959C27.4931 63.7016 27.5541 63.3749 27.5541 63.0159C27.5541 62.657 27.4931 62.3303 27.3711 62.0359C27.2562 61.7416 27.0911 61.4867 26.8757 61.2713C26.6675 61.0559 26.4198 60.8908 26.1326 60.7759C25.8454 60.6611 25.5331 60.6036 25.1957 60.6036C24.8582 60.6036 24.5459 60.6611 24.2588 60.7759C23.9788 60.8908 23.7311 61.0559 23.5157 61.2713C23.3003 61.4867 23.1316 61.7416 23.0095 62.0359C22.8947 62.3303 22.8372 62.657 22.8372 63.0159C22.8372 63.3677 22.8947 63.6944 23.0095 63.9959C23.1316 64.2903 23.2967 64.5452 23.5049 64.7605C23.7203 64.9759 23.9716 65.1411 24.2588 65.2559C24.5459 65.3708 24.8582 65.4282 25.1957 65.4282Z'
      fill='#ffffff'
    />
    <defs>
      <linearGradient
        id='paint0_linear_515_130'
        x1='37.4987'
        y1='24.1678'
        x2='59.3697'
        y2='35.2769'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCBA73' />
        <stop offset='1' stopColor='#B76E00' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_515_130'
        x1='16.6162'
        y1='24.3778'
        x2='33.0756'
        y2='29.419'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_515_130'
        x1='41.6955'
        y1='8.68616'
        x2='51.1025'
        y2='19.4748'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_515_130'
        x1='2.31531'
        y1='0'
        x2='2.31531'
        y2='27.6923'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#3169FF' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_515_130'
        x1='2.31531'
        y1='0'
        x2='2.31531'
        y2='27.6923'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#3169FF' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_515_130'
        x1='16.4482'
        y1='38.4767'
        x2='59.888'
        y2='63.0484'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_515_130'
        x1='8.9463'
        y1='57.1797'
        x2='22.6083'
        y2='70.8417'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#414CC8' />
        <stop offset='1' stopColor='#2B3493' />
      </linearGradient>
    </defs>
  </svg>,
  'FO',
);
